var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.02 21.25C17.1275 21.25 21.25 17.1075 21.25 11.98C21.25 6.8725 17.1275 2.75 12.02 2.75M12.02 21.25C6.8925 21.25 2.75 17.1075 2.75 11.98C2.75 6.8725 6.8925 2.75 12.02 2.75M12.02 21.25V2.75M20.026 7.375H3.98M20.0775 16.5125H3.9285M2.8 12H21.2",
    stroke: "#25AE35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.01 21.25C14.564 21.25 16.625 17.1075 16.625 11.98C16.625 6.8725 14.564 2.75 12.01 2.75C9.446 2.75 7.375 6.8725 7.375 11.98C7.375 17.1075 9.446 21.25 12.01 21.25Z",
    stroke: "#25AE35",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.0b215051abcd26a58066166a92560423.svg";
export { ForwardRef as ReactComponent };